import React from 'react';
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils';


export function DisclaimerWrapper({ children, }) {
  const blockName = 'community-disclaimer'
  return (
    <div className={`${blockName}__wrapper` }>
      { cloneChildrenWithProps(children, { blockName }) }
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/components/disclaimerWrapper.js